import { message, Button, Col, Form, Tag, Row, Space, Switch, Modal, Popconfirm, ProTableOt, ClassifyStructure } from "./../../ui/ot";
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import { useAutoReply } from "../controller/AutoReplyController";
import AutoReplyForm from "./AutoReplyForm";
import { useKeyword } from "../../keyword/controller/KeywordController";

const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const AutoReplyMain = () => {
    const columns = [
        {
            title: '標題',
            dataIndex: 'autoreply_name',
            key: 'autoreply_name',
        },
        {
            title: '自動回覆訊息',
            dataIndex: 'keyword_data',
            key: 'keyword',
            sorter: false,
            render: (text, record, _index) => {
                return (
                    <Space
                        direction='vertical'
                        wrap>
                        {
                            text.map((keyword_data) => {
                                return <Tag color="blue">{keyword_data?.keyword_name}</Tag>
                            })
                        }
                    </Space>
                )
            }
        },
        {
            title: '訊息樣板',
            dataIndex: 'can_data',
            key: 'can',
            sorter: false,
            render: (text, record, _index) => {

                return (
                    <Space
                        direction='vertical'
                        wrap>

                        {

                            text.map((keyword_data) => {
                                let content = '';
                                for (let i = 0; i < Object.keys(keyword_data).length; i++) {
                                    content = content + (keyword_data?.can_message[i] ?? { content: '' }).content;
                                }
                                return (<>
                                    <Tag color="green" >{keyword_data?.can_name}</Tag>
                                </>)
                            })
                        }
                    </Space>
                )
            }
        },
        {
            title: '是否啟用',
            dataIndex: 'activation',
            key: 'activation',
            render: (text, record, _index) => {
                return (
                    <Switch
                        disabled={true}
                        checked={text === 1}>

                    </Switch>
                )
            }
        },
        {
            title: '實施時間',
            dataIndex: 'active_date',
            key: 'active_date',
        },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.autoreply_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.autoreply_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.autoreply_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.autoreply_id)
                selectRow = selectRow.filter(row => row.autoreply_id !== record.autoreply_id)
            }
            setSelectedRowKeys(pre => select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        form.resetFields()

        let can_datas = record?.can_data
        let can_data_first = can_datas.find(ele => true)
        let can_id = can_data_first?.can_id

        let keyword_datas = record?.keyword_data
        let keyword_id = keyword_datas?.map((keyword_data) => {
            return {
                label: keyword_data?.keyword_name,
                value: keyword_data?.keyword_id
            }
        })
        let editData = {
            autoreply_id: record?.autoreply_id,
            can_id,
            keyword_id,
            "autoreply_name": record?.autoreply_name,
            "active_date": record?.active_date,
            "active_time": record?.active_time,
            "activation": record?.activation === 1 ? true : false
        }
        form.setFieldsValue({
            ...editData,
        })
    }
    const handleDeleteRow = (id) => {
        let data = []
        if (id) {
            data = [{
                autoreply_id: id
            }]
        }

        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    autoreply_id: val?.autoreply_id
                }
            })
        }
        if (data.length > 0) {
            deleteAutoReplyData(data)
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {

            let data = {
                "autoreply_name": values?.autoreply_name,
                "can_id": values?.can_id,
                "activation": !!values.activation ? 1 : 0,
                "keyword_data": values.keyword_data
            }
            postAutoReplyData([data])
        }
        else if (axiosMode === "patch") {

            let data = [
                {
                    autoreply_id: values?.autoreply_id,
                    can_id: values?.can_id,
                    keyword_data: values?.keyword_data,
                    autoreply_name: values?.autoreply_name,
                    active_date: values?.active_date,
                    active_time: values?.active_time,
                    activation: !!values.activation ? 1 : 0,
                }
            ]
            patchAutoReplyData(data)
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }


    const {
        getAutoReplyData,
        postAutoReplyData,
        patchAutoReplyData,
        deleteAutoReplyData
    } = useAutoReply({
        onFinish,
        onBefore,
    })

    const {
        getKeywordOption,
        keywordOption
    } = useKeyword({
        onFinish: () => { },
        onBefore: () => { },
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    useEffect(() => {
        checkAll()
        getKeywordOption()
    }, [])

    return <Row>

        <Col span={24}>
            <ProTableOt
                actionRef={actionRef}
                headerTitle={<></>}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={'autoreply_id'}
                selections={{
                    // onChange: (index_, data_) => set_data(data_)
                }}
                toolBarRender={() => [
                ]}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get")
                    let newParams = {
                    };
                    let order = setOrders(sort)
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20)
                    return getAutoReplyData(newParams)
                }}
                pageSize={pageSize}
                rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys: selectedRowKeys,
                    ...rowSelection,
                }}
                tableAlertOptionRender={() => {
                    return (
                        <Space size={16}>
                            {/* <Typography.Link>匯出資料</Typography.Link> */}
                        </Space>
                    )
                }}
                tableAlertRender={({
                    selectedRowKeys,
                    selectedRows,
                    // onCleanSelected,
                }) => {
                    return (
                        <Space size={24}>
                            <span>
                                已選擇 {selectedRowKeys.length} 項
                                <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                    取消選擇
                                </a>
                            </span>
                        </Space>
                    );
                }}
                scroll={{
                    x: "max-content"
                }}
                PropsPatchForm={<AutoReplyForm />}
                propsUseData={() => {
                    return {
                        postData: (value) => {
                            let datas = []
                            value.forEach(values => {
                                let keyword_data = (values?.keyword_id??[])?.map((keyword_value) => {
                                    let keyword = keywordOption.find((ele) => ele.keyword_id === keyword_value.value)
                                    if (keyword) {
                                        return {
                                            "keyword_id": keyword_value.value,
                                            "autoreply_id": keyword?.autoreply_id,
                                            "keyword_name": keyword_value.label,
                                        }
                                    }
                                    else {
                                        return {
                                            keyword_name: typeof keyword_value === 'object' ? keyword_value.value : keyword_value
                                        }
                                    }
                                })
                                datas.push({
                                    ...values,
                                    keyword_data
                                })
                            })
                            return postAutoReplyData(datas)
                        },
                        patchData: (value,...e) => {
                            let datas = []
                            value.forEach(values => {
                                let keyword_data = (values?.keyword_id??[])?.map((keyword_value) => {
                                    let keyword = keywordOption.find((ele) => ele.keyword_id === keyword_value.value)
                                    if (keyword) {
                                        return {
                                            "keyword_id": keyword_value.value,
                                            "autoreply_id": keyword?.autoreply_id,
                                            "keyword_name": keyword_value.label,
                                        }
                                    }
                                    else {
                                        return {
                                            keyword_name: typeof keyword_value === 'object' ? keyword_value.value : keyword_value
                                        }
                                    }
                                })
                                datas.push({
                                    ...values,
                                    keyword_data
                                })
                            });
                            return patchAutoReplyData(datas)
                        },
                        deleteData: deleteAutoReplyData
                    }
                }}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatchProcess={(record) => {
                    let can_datas = record?.can_data
                    let can_data_first = can_datas.find(ele => true)
                    let can_id = can_data_first?.can_id

                    let keyword_datas = record?.keyword_data
                    let keyword_id = keyword_datas?.map((keyword_data) => {
                        return {
                            label: keyword_data?.keyword_name,
                            value: keyword_data?.keyword_id
                        }
                    })
                    let editData = {
                        autoreply_id: record?.autoreply_id,
                        can_id,
                        keyword_id,
                        "autoreply_name": record?.autoreply_name,
                        "active_date": record?.active_date,
                        "active_time": record?.active_time,
                        "activation": record?.activation === 1 ? true : false
                    }
                    return {
                        ...editData,
                    }
                }}
                propsPatch
                propsPost
                propsDelete
                formMode={true}
            />
        </Col>
    </Row>
}


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
export default AutoReplyMain


